window.console.log(">>> kommt da was? 0003")

let laenge = null;
let breite = null;

window.console.log(">>> loaded", laenge, breite)

const calcPreise = () => {
  let preis = 0.00;
  if ( laenge && breite ) {
    preis = ((laenge * breite) / 100) + 20;
    window.console.log(">>> Preis", preis)
    document.getElementById("preis").innerHTML = preis;
  }
}

document.querySelector("input[name=laenge]").addEventListener('input', (e) => {
  laenge = e.target.value;
  calcPreise();
})

document.querySelector("input[name=breite]").addEventListener('input', (e) => {
  breite = e.target.value;
  calcPreise();
})